






import { Component, Vue } from "vue-property-decorator";
import {
  getRedirect
} from "@/services/api";
import YcHeader from "@/components/common/yc-header.vue";

@Component({
  components: {
    "yc-header": YcHeader,
  },
})
export default class Guide extends Vue {
  
  get token() {
    return localStorage.getItem("token") || "default";
  }

  

  created(): void {
    if( this.$route.query.shop || this.$route.query.handle || this.$route.query.integrationId === '31'){
      if ( this.$route.query?.state?.indexOf('from_cartsee_install') > 0|| this.$route.query?.customField?.indexOf('from_cartsee_install') >0) {
        window.location.href = '/cartsee-new/guide' + window.location.search 
      }else{
        if(this.$route.query.handle){
          if(String(this.$route.query.handle).split('.').length === 1){
            this.$router.replace({query:{
              ...this.$route.query,
              shop: this.$route.query.handle +'.myshopline.com'
            }}).catch(e=>e)
          }
        }
        this.callbackLogin()
      }
    }else{
      window.location.href = '/cartsee-new/guide' + window.location.search 
    }
    
  }
  callbackLogin(){
    getRedirect(
      {
        shop: this.$route.query.shop as string | null,
        token:localStorage.getItem("token")|| null as string|null,
        state: this.$route.query.state as string | null,
        customField: this.$route.query.customField as string | null,
        ...(this.$route.query.integrationId === '31' ? {
          shop: 'shopyy',
          integrationId: this.$route.query.integrationId,
          authorize_token_url: this.$route.query.authorize_token_url,
          code: this.$route.query.code,
        } : {})
      }, false
    ).then((res) => {
      if (res?.data?.data?.redirectPage === 'AUTO_LOGIN') {
        window.location.href = '/cartsee-new/guide' + window.location.search 
      }else{
        window.location.href = '/cartsee-new/login' + window.location.search +'&redirectPage='+ res.data.data.redirectPage+ '&shopName='+ res.data.data.shopName
      }
    })
  }

}
